import React from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import { get } from 'lodash';
import { Breadcrumb } from 'antd';
import { fetchWebhook } from '@api/notificationChannel';
import { StyledWebhooksContainer, StyledWebhookFormWrapper } from '../styled';
import WebhooksForm from '../Edit/WebhooksForm';

const { baseUrl } = window.conviva;

const Webhooks = ({ id }) => {
  const history = useHistory();
  const {
    data = null,
    error,
    isLoading,
  }: any = useQuery(
    ['webhook', id],
    () => {
      return fetchWebhook(id).then((response) => {
        return get(response, ['data'], {});
      });
    },
    {
      enabled: id !== undefined,
    },
  );

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  const navigateToWebhooks = () => {
    history.push(`${baseUrl}/settings/webhooks`);
  };

  return (
    <StyledWebhooksContainer>
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => navigateToWebhooks()}>Webhooks</Breadcrumb.Item>
        <Breadcrumb.Item>Create</Breadcrumb.Item>
      </Breadcrumb>
      <StyledWebhookFormWrapper>
        <WebhooksForm webhook={data ? data.data : {}} />
      </StyledWebhookFormWrapper>
    </StyledWebhooksContainer>
  );
};

export default Webhooks;
